import { render, staticRenderFns } from "./Collaborator.vue?vue&type=template&id=ca9f50d0&scoped=true"
import script from "./Collaborator.vue?vue&type=script&lang=js"
export * from "./Collaborator.vue?vue&type=script&lang=js"
import style0 from "./Collaborator.vue?vue&type=style&index=0&id=ca9f50d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9f50d0",
  null
  
)

export default component.exports